import { ValueOf } from './util';

export const EAggregationCategory = {
  TRANSACTION: '取引',
  CAMPAIGN: 'キャンペーン',
  BULK_GRANT: '一括付与',
  UNUSED_BALANCE: '基準日未使用残高',
} as const;

export type AggregationCategoryKey = keyof typeof EAggregationCategory;
export type AggregationCategoryValue = ValueOf<typeof EAggregationCategory>;

export const aggregationCategoryKeys = Object.keys(EAggregationCategory) as (AggregationCategoryKey[]);

/** v-select用items */
export const aggregationCategoryItems = aggregationCategoryKeys
  .map((key) => ({
    title: EAggregationCategory[key],
    value: key,
  }));
